export const typePayoutsEn = {
  Single: 'All except bulk',
  All: 'All, including bulk',
  Bulk: 'Bulk only',
} as const;

export type TTypePayoutsEnKeys = keyof typeof typePayoutsEn;

export const typePayoutsRu: Record<TTypePayoutsEnKeys, string> = {
  Single: 'Все, кроме массовых',
  All: 'Все, включая массовые',
  Bulk: 'Только массовые',
} as const;

